module.exports = __webpack_public_path__ + "media/images/cc_icon-104e8188c29afd52e1a312ce1586ab4c.svg";